import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DeferredFragmentIdentifieryfmj5mbsp1mh as DeferredFragmentIdentifier } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/DeferredFragmentIdentifier.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { BufferedSourceJsonReader1eguw7qhrwt7p as BufferedSourceJsonReader } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/BufferedSourceJsonReader.mjs';
import { readAny17j2jqaxubdko as readAny } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function mergeData($this, incrementalItem) {
  var tmp = incrementalItem.z4('data');
  var data = (tmp == null ? true : isInterface(tmp, KtMap())) ? tmp : THROW_CCE();
  var tmp_0 = incrementalItem.z4('path');
  var path = (!(tmp_0 == null) ? isInterface(tmp_0, KtList()) : false) ? tmp_0 : THROW_CCE();
  var tmp_1 = $this.p65_1.z4('data');
  var mergedData = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap()) : false) ? tmp_1 : THROW_CCE();
  if (!(data == null)) {
    var tmp_2 = nodeAtPath($this, mergedData, path);
    var nodeToMergeInto = (!(tmp_2 == null) ? isInterface(tmp_2, KtMutableMap()) : false) ? tmp_2 : THROW_CCE();
    deepMerge($this, nodeToMergeInto, data);
    var tmp0 = $this.q65_1;
    var tmp_3 = incrementalItem.z4('label');
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new (DeferredFragmentIdentifier())(path, (tmp_3 == null ? true : typeof tmp_3 === 'string') ? tmp_3 : THROW_CCE());
    tmp0.n2(element);
  }
}
function deepMerge($this, destination, map) {
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = map.q3().u1();
  while (_iterator__ex2g4s.v1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.w1();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.r3();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.s3();
    var tmp;
    if (destination.x4(key)) {
      var tmp_0 = destination.z4(key);
      tmp = !(tmp_0 == null) ? isInterface(tmp_0, KtMutableMap()) : false;
    } else {
      tmp = false;
    }
    if (tmp) {
      var tmp_1 = destination.z4(key);
      var fieldDestination = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap()) : false) ? tmp_1 : THROW_CCE();
      var tmp0_elvis_lhs = (!(value == null) ? isInterface(value, KtMap()) : false) ? value : null;
      var tmp_2;
      if (tmp0_elvis_lhs == null) {
        var message = "'" + key + "' is an object in destination but not in map";
        throw IllegalStateException().o(toString(message));
      } else {
        tmp_2 = tmp0_elvis_lhs;
      }
      var fieldMap = tmp_2;
      deepMerge($this, fieldDestination, fieldMap);
    } else {
      // Inline function 'kotlin.collections.set' call
      destination.c5(key, value);
    }
  }
}
function jsonToMap($this, json) {
  var tmp = readAny(new (BufferedSourceJsonReader())(json));
  return (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE();
}
function nodeAtPath($this, map, path) {
  var node = map;
  var _iterator__ex2g4s = path.u1();
  while (_iterator__ex2g4s.v1()) {
    var key = _iterator__ex2g4s.w1();
    var tmp;
    if (!(node == null) ? isInterface(node, KtList()) : false) {
      var tmp_0 = node;
      tmp = tmp_0.w2(typeof key === 'number' ? key : THROW_CCE());
    } else {
      if (!(!(node == null) ? isInterface(node, KtMap()) : false))
        THROW_CCE();
      // Inline function 'kotlin.collections.get' call
      var this_0 = node;
      tmp = (isInterface(this_0, KtMap()) ? this_0 : THROW_CCE()).z4(key);
    }
    node = tmp;
  }
  return node;
}
var DeferredJsonMergerClass;
function DeferredJsonMerger() {
  if (DeferredJsonMergerClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.o65_1 = LinkedHashMap().gc();
        this.p65_1 = this.o65_1;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableSetOf' call
        tmp_0.q65_1 = LinkedHashSet().x2();
        this.r65_1 = this.q65_1;
        this.s65_1 = true;
        this.t65_1 = false;
      }
      u65(payload) {
        var payloadMap = jsonToMap(this, payload);
        return this.v65(payloadMap);
      }
      v65(payload) {
        if (this.p65_1.s1()) {
          // Inline function 'kotlin.collections.plusAssign' call
          this.o65_1.e5(payload);
          return this.p65_1;
        }
        var tmp = payload.z4('incremental');
        var incrementalList = (!(tmp == null) ? isInterface(tmp, KtList()) : false) ? tmp : null;
        if (incrementalList == null) {
          this.t65_1 = true;
        } else {
          this.t65_1 = false;
          // Inline function 'kotlin.collections.mutableListOf' call
          var mergedErrors = ArrayList().u2();
          // Inline function 'kotlin.collections.mutableListOf' call
          var mergedExtensions = ArrayList().u2();
          var _iterator__ex2g4s = incrementalList.u1();
          while (_iterator__ex2g4s.v1()) {
            var incrementalItem = _iterator__ex2g4s.w1();
            mergeData(this, incrementalItem);
            var tmp_0 = incrementalItem.z4('errors');
            var tmp0_safe_receiver = (!(tmp_0 == null) ? isInterface(tmp_0, KtList()) : false) ? tmp_0 : null;
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.plusAssign' call
              addAll(mergedErrors, tmp0_safe_receiver);
            }
            var tmp_1 = incrementalItem.z4('extensions');
            var tmp1_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap()) : false) ? tmp_1 : null;
            if (tmp1_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.plusAssign' call
              mergedExtensions.n2(tmp1_safe_receiver);
            }
          }
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!mergedErrors.s1()) {
            // Inline function 'kotlin.collections.set' call
            this.o65_1.c5('errors', mergedErrors);
          } else {
            this.o65_1.d5('errors');
          }
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!mergedExtensions.s1()) {
            var tmp0 = this.o65_1;
            var tmp2 = 'extensions';
            // Inline function 'kotlin.collections.set' call
            var value = mapOf(to('incremental', mergedExtensions));
            tmp0.c5(tmp2, value);
          } else {
            this.o65_1.d5('extensions');
          }
        }
        var tmp_2 = this;
        var tmp_3 = payload.z4('hasNext');
        var tmp2_elvis_lhs = (tmp_3 == null ? true : typeof tmp_3 === 'boolean') ? tmp_3 : THROW_CCE();
        tmp_2.s65_1 = tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
        return this.p65_1;
      }
      c3o() {
        this.o65_1.f5();
        this.q65_1.f5();
        this.s65_1 = true;
        this.t65_1 = false;
      }
    }
    initMetadataForClass($, 'DeferredJsonMerger', DeferredJsonMerger);
    DeferredJsonMergerClass = $;
  }
  return DeferredJsonMergerClass;
}
function isDeferred(_this__u8e3s4) {
  return _this__u8e3s4.a5().y2('hasNext');
}
//region block: exports
export {
  DeferredJsonMerger as DeferredJsonMerger16i62uujz1qml,
  isDeferred as isDeferred3jq83655znees,
};
//endregion

//# sourceMappingURL=DeferredJsonMerger.mjs.map
